import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Reveal — subtle entrance animation (opacity + small translateY).
 * Respects prefers-reduced-motion. Used only on section wrappers / cards.
 */
export const Reveal = ({ children, delay = 0, y = 12, className, ...props }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={reduce ? {} : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1], delay }}
      {...props}
    >
      {children}
    </motion.div>
  );
};
